import { DragOverlay } from "@dnd-kit/core";
import { OpenWith } from "@mui/icons-material";
import { FC } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { DragTypeEnum, ridesDraggingDataAtom } from "@ryde/shared";
import { orangeMui } from "@ryde/theme";

import {
  KanbanItem,
  RidesKanbanItemPassengersRowDragOverlay,
} from "../../search";
import {
  snapMouseToContainer,
  VERTICAL_DRAG_PASSENGER_CORRECTION,
  VERTICAL_DRAG_RIDE_CORRECTION,
} from "./drag-restriction-helpers";
import { RideRowReplacementBoxDragging } from "./rides.drag-overlays.styled";
import {
  countDragPassengers,
  dragPassengersLabel,
} from "./rides.drag-overlays.utils";

export const RidesDragOverlaysWrapper: FC = () => {
  const { t } = useTranslation();
  const { type: dragType, payload: dragPayload } = useRecoilValue(
    ridesDraggingDataAtom,
  );

  return (
    <>
      {dragType === DragTypeEnum.GRID_PASSENGER &&
        dragPayload?.rideDto?.id &&
        createPortal(
          <DragOverlay
            dropAnimation={null}
            modifiers={[
              snapMouseToContainer(VERTICAL_DRAG_PASSENGER_CORRECTION),
            ]}
          >
            <RideRowReplacementBoxDragging>
              <OpenWith htmlColor={orangeMui._900} />
              {t("ride.RIDE_DRAG_AND_DROP_INFO", {
                rideId: dragPayload.rideDto?.id,
                numPassengers: countDragPassengers(dragPayload),
              })}
            </RideRowReplacementBoxDragging>
          </DragOverlay>,
          document.body,
        )}
      {dragType === DragTypeEnum.GRID_RIDE &&
        createPortal(
          <DragOverlay
            dropAnimation={null}
            modifiers={[snapMouseToContainer(VERTICAL_DRAG_RIDE_CORRECTION)]}
          >
            <RideRowReplacementBoxDragging>
              <OpenWith htmlColor={orangeMui._900} />
              {t("ride.RIDE_DRAG_AND_DROP_INFO", {
                rideId: dragPayload.rideDto?.id,
                numPassengers: dragPayload.rideDto?.metadata?.seatsCount || 0,
              })}
            </RideRowReplacementBoxDragging>
          </DragOverlay>,
          document.body,
        )}
      {dragType === DragTypeEnum.KANBAN_PASSENGER && (
        <DragOverlay dropAnimation={null}>
          <RidesKanbanItemPassengersRowDragOverlay
            passenger={{
              ...dragPayload.passenger,
              firstName: dragPassengersLabel(dragPayload, t),
            }}
            rideDto={dragPayload.rideDto}
            dragSelectedIds={dragPayload.dragSelectedIds}
          />
        </DragOverlay>
      )}
      {(dragType === DragTypeEnum.KANBAN_RIDE ||
        dragType === DragTypeEnum.CARD_BOARD_RIDE) && (
        <DragOverlay dropAnimation={null}>
          <KanbanItem isDragClone={true} rideDto={dragPayload.rideDto} />
        </DragOverlay>
      )}
    </>
  );
};
